import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react/macro";

import { cn } from "@/shared/lib";

import type { DrillAnswer, DrillSpec } from "../../model/Drill";
import { OptionButton } from "./OptionButton";
import { OptionContent } from "./OptionContent";
import { useOptionView } from "./useOptionView";

const PLACED = msg({ message: "{name}, place {place}" });

type OrderOptionsProps = {
  spec: DrillSpec;
  answer: DrillAnswer;
  graded: boolean;
  locked: boolean;
  onChange: (answer: DrillAnswer) => void;
};

// Порядок: нажимаешь варианты по очереди — у каждого номер места; повторное нажатие
// убирает вариант. После ответа на своём месте — зелёный, нет — красный.
export const OrderOptions = ({ spec, answer, graded, locked, onChange }: OrderOptionsProps) => {
  const { i18n } = useLingui();
  const view = useOptionView();
  const toggle = (id: string) => {
    const placed = answer.option_ids.includes(id);
    onChange({
      ...answer,
      option_ids: placed
        ? answer.option_ids.filter((optionId) => optionId !== id)
        : [...answer.option_ids, id],
    });
  };
  return (
    <div className="grid grid-cols-[repeat(auto-fit,minmax(200px,1fr))] gap-3">
      {spec.options.map((option) => {
        const at = answer.option_ids.indexOf(option.id);
        const placed = at >= 0;
        const optionView = view(option);
        let state: "idle" | "picked" | "right" | "wrong" = placed ? "picked" : "idle";
        if (graded) {
          state = spec.correct_ids[at] === option.id ? "right" : "wrong";
        }
        return (
          <OptionButton
            key={option.id}
            state={state}
            pressed={placed}
            locked={locked}
            label={
              placed
                ? i18n._({ ...PLACED, values: { name: optionView.name, place: at + 1 } })
                : optionView.name
            }
            onClick={() => {
              toggle(option.id);
            }}
          >
            <span
              aria-hidden="true"
              className={cn(
                "inline-flex size-7 shrink-0 items-center justify-center rounded-full font-mono text-sm font-semibold",
                placed ? "bg-accent text-accent-foreground" : "bg-sidebar-active text-subtle",
              )}
            >
              {placed ? at + 1 : "·"}
            </span>
            <OptionContent view={optionView} size={44} />
          </OptionButton>
        );
      })}
    </div>
  );
};
